


























import { Component, Prop, Vue } from 'vue-property-decorator';

import CloseModalIcon from '@/components/icons/CloseModal.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';

@Component({
  components: {
    CloseModalIcon,
    FilledButton
  }
})
export default class HighlightCard extends Vue {
  @Prop(String) title!: string;
  @Prop(String) description!: string;
  @Prop(String) actionLabel!: string;
  @Prop({ default: '318px' }) width?: string;
}
